module.exports = __webpack_public_path__ + "img/20200508_175932.a8bbead5.jpg";